<template>
  <va-edit-layout>
    <sliders-form :id="id" :title="title" :item="item"></sliders-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
